import { Modal, Button } from "react-bootstrap";
import { useState, useEffect, useContext, useRef } from "react";
import Loading from "../../../../components/Loading";
import EventFormRequest from "../form/EventFormRequest";
import { toast } from "react-toastify";
import { Grid } from "../../../Layout/Grid/GridView";

function GuestlistPromotersModal({
  show,
  handleModalShow,
  handleModalhide,
  paramsEvent,
  handlerSelectPromoter,
  handlerSubmitPromoters,
}) {
  // const [show, setShow] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const gridRef = useRef();
  const [state, setState] = useState({
    list: [],
  });

  useEffect(() => {
    if (show)
      getListPromoters();
  }, [show]);

  const getListPromoters = async () => {
    setIsLoading(true);
    let params = paramsEvent;
    let info = await EventFormRequest.getListPromoterEvent(params);
    if (info && info.status) {
      setState({
        ...state,
        list: info.data.promotersList,
      });
    }
    setIsLoading(false);
  }

  const changePromoterAccess = async (data, field) => {
    // Validar o campo
    const validFields = ["isGuestlistActive", "isTablesActive", "isTicketsActive"];
    if (!validFields.includes(field)) {
      toast.error("Campo inválido!");
      return;
    }


    let params = {
      promoterId: data.id,
      id_events: paramsEvent.id,
      id_venues: paramsEvent.id_venues,
      isGuestlistActive: data.isGuestlistActive,
      isTablesActive: data.isTablesActive,
      isTicketsActive: data.isTicketsActive,
      [field]: data[field] === 1 ? 0 : 1,
    };

    // Fazer a requisição
    let info = await EventFormRequest.changePromoterAccess(params);
    if (info && info.status) {
      getListPromoters();
      toast.success("Promotor atualizado com sucesso!", { theme: "dark", });
    } else {
      toast.error("Erro ao atualizar promotor!", { theme: "dark", });
    }
  };


  const checkboxRenderer = ({ value }) => {
    return <input type="checkbox" checked={value} readOnly />;
  };

  return (
    <>
      <Modal show={show} onHide={handleModalhide} centered contentClassName="campaign-card border-0 shadow-lg" size="lg">
        <Modal.Header className="border-0 d-flex align-items-center">
          <Modal.Title className="fw-bold">
            <i className="fa-solid fa-users me-2 text-primary"></i>
            Lista de Promotores
          </Modal.Title>
          <button
            type="button"
            className="btn btn-sm rounded-circle d-flex align-items-center justify-content-center ms-auto border-0 bg-white bg-opacity-10 hover-scale"
            onClick={handleModalhide}
            style={{
              width: '36px',
              height: '36px',
              transition: 'all 0.2s ease'
            }}
          >
            <i className="fa-solid fa-xmark text-white fs-5"></i>
          </button>
        </Modal.Header>

        <Modal.Body>
          {isLoading ? <Loading /> :
            <div className="row">
              <div className="col-12 event-list-table">

                <Grid
                  ref={gridRef}
                  rows={state.list}
                  cols={[
                    { hide: true, field: "id" },
                    { headerName: "Nome", field: "Nome" },
                    {
                      headerName: "Guest List",
                      field: "isGuestlistActive",
                      cellRenderer: checkboxRenderer,
                      cellEditor: 'agCheckboxCellEditor',
                      editable: true,
                      cellClass: "actions-button-cell",
                      cellStyle: { textAlign: "center" },
                      onCellClicked: (e) => {
                        changePromoterAccess(e.data, "isGuestlistActive");
                      },
                    },
                    {
                      headerName: "Mesas",
                      field: "isTablesActive",
                      cellRenderer: checkboxRenderer,
                      cellEditor: 'agCheckboxCellEditor',
                      editable: true,
                      cellClass: "actions-button-cell",
                      cellStyle: { textAlign: "center" },
                      onCellClicked: (e) => {
                        changePromoterAccess(e.data, "isTablesActive");
                      },
                    },
                    {
                      headerName: "Bilhetes",
                      field: "isTicketsActive",
                      cellRenderer: checkboxRenderer,
                      editable: true,
                      cellStyle: { textAlign: "center" },
                      onCellClicked: (e) => {
                        changePromoterAccess(e.data, "isTicketsActive");
                      },
                    },
                  ]}
                />
              </div>
            </div>
          }
        </Modal.Body>
      </Modal>
      {/* <ToastContainer /> */}
    </>
  );
}

export default GuestlistPromotersModal;
